import { PATHS } from '@efacity/routing';
import { useState } from 'react';

import {
  ShoppingCartIconWithTable,
  navigateWithPageReload,
  setKitPurchaseProgress,
  setRegistrationProgress,
  useAuth
} from '@efacity/react-next-sc';

export const HeaderShoppingCart = () => {
  const {
    clearShoppingCartOnServer,
    authState: { extraAuthInfo }
  } = useAuth();
  const { shoppingCart, startRegistrationURL } = extraAuthInfo;

  const [isClearingShoppingCart, setIsClearingShoppingCart] = useState(false);
  const clearShoppingCart = async () => {
    setIsClearingShoppingCart(true);
    await clearShoppingCartOnServer();
    setRegistrationProgress(false);
    setKitPurchaseProgress(false);
    setIsClearingShoppingCart(false);
    navigateWithPageReload(startRegistrationURL ? startRegistrationURL : PATHS.landing);
  };
  const gotoShoppingCartPage = () => {
    navigateWithPageReload(PATHS.cart);
  };

  if (!shoppingCart) return null;
  return (
    <ShoppingCartIconWithTable
      shoppingCart={shoppingCart}
      isClearing={isClearingShoppingCart}
      clearShoppingCart={clearShoppingCart}
      gotoShoppingCartPage={gotoShoppingCartPage}
    />
  );
};
